/**
 * Report registry.
 *
 * The report-agnostic Report Generator page consumes this — never a specific
 * report module. Adding a new report type (e.g. Board's Report, Secretarial
 * Audit) is a two-line change: import its descriptor and add it to REPORTS.
 * Each descriptor follows the contract documented in auditorReport/index.js.
 */
import auditorReport from './auditorReport';

export const REPORTS = [
  auditorReport,
  // import boardReport from './boardReport'; → add here
];

export const DEFAULT_REPORT_ID = auditorReport.id;

/** Look up a report descriptor by id; falls back to the first registered report. */
export function getReport(id) {
  return REPORTS.find((r) => r.id === id) || REPORTS[0];
}
